export default __webpack_public_path__ + "static/who-87689de9cb6fbe032bbb67588dfcc164.jpg";